import styled from '@emotion/styled';
import SelectBase, { components } from 'react-select';

import Async from './Select/Async';
import { bootstrapStyles } from './Select/styles';
import { createStyledSelect } from './Select/helpers';
import { Props } from 'react-select';
import { isEmpty } from 'lodash';

export { components };

export const createInputChangeHandler = (
  updateQuery: (query?: string) => void
): Props['onInputChange'] => {
  return (inputValue: string | undefined, { action }) => {
    switch (action) {
      case 'input-change':
        if (!isEmpty(inputValue?.trim())) {
          updateQuery(inputValue);
        } else {
          updateQuery(undefined);
        }
        break;
    }
  };
};

const Select = styled(createStyledSelect(SelectBase, bootstrapStyles))``;

Select.Async = Async;

export default Select;
